class State {
	constructor() {
		this.states = {};
		this.subscribers = {};
	}

	get(id, key) {
		const stateObj = this.states[id];
		if (!(this.states && this.states.hasOwnProperty(id))) return null;
		if (!stateObj || !stateObj.hasOwnProperty(key)) {
			// Handle error case
			console.error(`Invalid id or key. id: ${id}, key: ${key}`);
			return null;
		}
		return stateObj[key];
	}

	set(id, key, value) {
		this.states[id][key] = value;
		this.notifySubscribers(id, key, value);
	}

	update(id, key, updater) {
		this.states[id][key] = updater(this.states[id][key]);
		this.notifySubscribers(id, key);
	}

	setState(id, newState) {
		this.states[id] = { ...this.states[id], ...newState };
		this.notifySubscribers(id);
	}

	getState(id) {
		return this.states[id];
	}

	subscribe(id, key, callback) {
		if (!this.subscribers.hasOwnProperty(id)) {
			this.subscribers[id] = {};
		}

		if (!this.subscribers[id].hasOwnProperty(key)) {
			this.subscribers[id][key] = [];
		}

		this.subscribers[id][key].push(callback);
	}

	unsubscribe(id, key, callback) {
		if (
			!this.subscribers.hasOwnProperty(id) ||
			!this.subscribers[id].hasOwnProperty(key)
		) {
			return;
		}

		const callbacks = this.subscribers[id][key];
		const index = callbacks.indexOf(callback);
		if (index !== -1) {
			callbacks.splice(index, 1);
		}
	}

	notifySubscribers(id, key, value) {
		// Notify observers of key update
		if (
			this.subscribers.hasOwnProperty(id) &&
			this.subscribers[id].hasOwnProperty(key)
		) {
			let callbacks = this.subscribers[id];
			if (!key) {
				callbacks = this.subscribers[id][key];
			}
			for (let i = 0; i < callbacks.length; i++) {
				callbacks[i](value);
			}
		}
	}
}

const state = new State();

export default state;
